import i18next from "../../common/localization/i18n";

const UtmData = [
  { value: "utm_source", text: i18next.t("NEW_FORM_EDITOR.SINGLE_INPUT.UTM.UTM_SOURCE") },
  { value: "utm_medium", text: i18next.t("NEW_FORM_EDITOR.SINGLE_INPUT.UTM.UTM_MEDIUM") },
  {
    value: "utm_campaign",
    text: i18next.t("NEW_FORM_EDITOR.SINGLE_INPUT.UTM.UTM_CAMPAIGN"),
  },
  { value: "utm_term", text: i18next.t("NEW_FORM_EDITOR.SINGLE_INPUT.UTM.UTM_TERM") },
  {
    value: "utm_content",
    text: i18next.t("NEW_FORM_EDITOR.SINGLE_INPUT.UTM.UTM_CONTENT"),
  },
];

export default UtmData;
